import React from 'react';

const Newsletter = () => {
  const franchiseFeatures = [
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Proven System',
      description: 'Complete business blueprint tested and refined over years of success',
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: 'Turnkey Operations',
      description: 'Marketing, systems, and support - everything you need to launch and scale',
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Location Freedom',
      description: 'Run your business from anywhere - no office, no location constraints',
    },
  ];

  return (
    <section id="franchise" className="bg-gradient-to-br from-cream to-white py-24">
      <div className="section-container">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Build Your Location-Independent Business?
            </h2>
            <p className="text-xl text-gray-brown">
              Join the first cleaning franchise specializing in short-term rental cleaning.
              Build a profitable business with complete freedom.
            </p>
          </div>

          {/* Franchise CTA Card */}
          <div className="bg-white rounded-3xl shadow-deep p-8 md:p-12 mb-12">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Left Side - Franchise Info */}
              <div>
                <div className="inline-block bg-gradient-to-r from-primary to-secondary text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                  🚀 Franchise Opportunity
                </div>
                <h3 className="text-3xl md:text-4xl font-bold mb-4 text-dark-brown">
                  MaidThis Franchise
                </h3>
                <p className="text-lg text-gray-brown mb-6 leading-relaxed">
                  The first and only cleaning franchise designed for true location independence.
                  Get access to the exact systems, marketing, and support that built MaidThis
                  into a 7-figure company.
                </p>

                {/* Features List */}
                <div className="space-y-3 mb-6">
                  {franchiseFeatures.map((feature, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-10 h-10 bg-primary bg-opacity-10 rounded-lg flex items-center justify-center text-primary">
                        {feature.icon}
                      </div>
                      <div>
                        <h4 className="font-bold text-dark-brown mb-1">{feature.title}</h4>
                        <p className="text-sm text-gray-brown">{feature.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Side - CTA */}
              <div className="bg-gradient-to-br from-primary via-secondary to-accent p-1 rounded-2xl">
                <div className="bg-white rounded-2xl p-8 text-center">
                  <div className="mb-6">
                    <div className="text-5xl font-bold text-dark-brown mb-2">
                      Get Started
                    </div>
                    <p className="text-gray-brown">
                      Join ambitious entrepreneurs building location-independent cleaning businesses
                    </p>
                  </div>

                  <a
                    href="https://maidthisfranchise.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full btn-primary text-lg py-4 mb-4"
                  >
                    Explore Franchise
                  </a>

                  <div className="space-y-3 text-sm text-gray-brown">
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <span>Complete Training & Support</span>
                    </div>
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <span>Marketing Systems Included</span>
                    </div>
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <span>Specialized in STR Cleaning</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Social Connect Section */}
          <div className="text-center pt-12 border-t border-gray-200">
            <h3 className="text-2xl font-bold mb-6 text-dark-brown">
              Connect With Me
            </h3>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="https://twitter.com/NeelBParekh"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-6 py-3 bg-white rounded-xl shadow-crisp hover:shadow-deep transition-all card-hover"
              >
                <svg className="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
                <span className="font-medium text-gray-brown">Follow on Twitter</span>
              </a>

              <a
                href="https://www.linkedin.com/in/neelparekh/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-6 py-3 bg-white rounded-xl shadow-crisp hover:shadow-deep transition-all card-hover"
              >
                <svg className="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                <span className="font-medium text-gray-brown">Connect on LinkedIn</span>
              </a>

              <a
                href="https://www.beremotelocal.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-6 py-3 bg-white rounded-xl shadow-crisp hover:shadow-deep transition-all card-hover"
              >
                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                </svg>
                <span className="font-medium text-gray-brown">Listen to Podcast</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
